"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Highlighted = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Highlighted = exports.Highlighted = /*#__PURE__*/(0, _base.default)("mark", process.env.NODE_ENV === "production" ? {
  target: "e1odo87v0"
} : {
  target: "e1odo87v0",
  label: "Highlighted"
})(process.env.NODE_ENV === "production" ? {
  name: "1qu152t",
  styles: "padding:2px 0;border-radius:4px;background-color:#ffff8f"
} : {
  name: "1qu152t",
  styles: "padding:2px 0;border-radius:4px;background-color:#ffff8f",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});